var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowSolidRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons_Utility_16px",
    "data-name": "Icons / Utility / 16px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.003,
    height: 16.168,
    viewBox: "0 0 16.003 16.168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow-right-solid",
    d: "M6.8,38.695,7.6,37.9a.854.854,0,0,1,1.211,0l6.943,6.94a.854.854,0,0,1,0,1.211L8.808,53A.854.854,0,0,1,7.6,53L6.8,52.2a.858.858,0,0,1,.014-1.225l4.3-4.1H.857A.855.855,0,0,1,0,46.02V44.877a.855.855,0,0,1,.857-.857H11.122l-4.3-4.1A.852.852,0,0,1,6.8,38.695Z",
    transform: "translate(0 -37.65)",
    fill: "#B70303"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "_16px",
    "data-name": "16px",
    width: 16,
    height: 16,
    transform: "translate(0 0.168)",
    fill: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSolidRight);
export default __webpack_public_path__ + "static/media/arrow-solid-right.21c21b12.svg";
export { ForwardRef as ReactComponent };